<template>
	<div class="bind_box">
		<div class="title">
			<p>为了您的账号安全,</p>
			<p>请绑定手机号</p>
			<p class="line"></p>
		</div>
		<div class="info">
			<div class="phone">
				<input type="text" name="" id="" placeholder="请输入手机号码" maxlength="12" v-model="phone"/>
			</div>
			<div class="code">
				<input type="text" name="" id="" placeholder="请输入验证码" maxlength="10" v-model="code"/>
				<p class="getCode" @click="getCode">{{codeText}}</p>
			</div>
		</div>
		<div class="btn_area" @click="login"></div>
		<div class="decoration"></div>
	</div>
</template>

<script>
	import {rechargeParam} from '../assets/js/common.js'
	
	export default{
		data(){
			return {
				phone:"",
				code:"",
				codeText:"获取验证码",
				countdown:60,
				userData:{}
			}
		},
		created(){
//			console.log(localStorage.getItem('openid'))
//			console.log(localStorage.getItem('nickname'))
//			console.log(localStorage.getItem('gender'))
//			console.log(localStorage.getItem('avatar'))
		},
		methods:{
			login(){
				if(this.phone=='' || this.code==''){
					alert("请填写相关信息");
				}else if(!(/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/).test(this.phone)){
					alert("请填写正确的手机号码");
				}else{
					this.$http.post("/api/v2/user/bind?"+rechargeParam({},true,true),{
						mobile:this.phone,
				       	code:this.code,
				       	from:this.isAlipayOrWechat().split(',')[0],
			       		uuid:localStorage.getItem('openid'),
					    nickname:localStorage.getItem('nickname'),
						gender:localStorage.getItem('gender'),
						avatar:localStorage.getItem('avatar')
					},{emulateJSON:true}).then((response) => {
						if(response.data.error == 0){
							alert("绑定成功");
							localStorage.setItem("token",response.data.data);
							this.$router.push(localStorage.getItem('currentRouter'))
						}else if(response.data.error == "11002"){
							this.$emit("getToken");
						}else{
							alert(response.data.msg);
							
						}
					})
				}
			},
			getCode(){
				if(this.codeText=="获取验证码"){
					if(this.phone==''){
						alert("请填写手机号码")
					}else if(!(/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/).test(this.phone)){
						alert("请填写正确的手机号码");
					}else{
						this.$http.post("/api/v2/verify/send?"+rechargeParam({},true,true),{
							mobile:this.phone 
						},{emulateJSON:true}).then((response) => {
							if(response.data.error == 0){
								this.settime();
								
							}else if(response.data.error == "11002"){
								this.$emit("getToken");
//								this.refreshToken();
							}else{
								alert(response.data.msg);
								
							}
						})
					}
				}else{
					alert("操作频繁，请稍后重试")
				}
				
			  },
			  settime(){
	  			let timer = setInterval(() => {
			      	if (this.countdown <= 0) {  
			        		this.codeText="获取验证码";  
			        		this.countdown = 60;  
			        		clearInterval(timer);  
			        		
			      	} else {
			       		this.codeText=this.countdown;  
			        		this.countdown--;  
			      	}  
		  		},1000)
			  }
		}
	}
</script>

<style scoped="scoped">
	.bind_box{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #FFFFFF;
		/*background: url(../assets/img/bind_bg@2x.png) no-repeat;
		background-size: 100%;*/
	}
	.bind_box .title{
		padding: 0.74rem 0 1rem 0.3rem;
	}
	.bind_box .title p{
		font-size:0.44rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(82,82,82,1);
	}
	.bind_box .title .line{
		margin-top: 0.2rem;
		width:1.73rem;
		height:0.14rem;
		background:rgba(82,82,82,1);
	}
	.info .phone,.info .code{
		margin: 0 auto;
		width: 6.62rem;
		height: 0.78rem;
		line-height: 0.78rem;
		border-bottom: 0.02rem solid rgba(216,216,216,1);
	}
	.info .code{
		position: relative;
		margin-top: 1.1rem;
	}
	input{
		background: none;
		height: 0.76rem;
		line-height: 0.76rem;
		border: none;
		font-size:0.36rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		/*color:rgba(216,216,216,1);*/
		outline: none;
	}
	.info .code .getCode{
		position: absolute;
		right: 0;
		bottom: 0.06rem;
		width:2.27rem;
		height:0.64rem;
		line-height: 0.64rem;
		background:rgba(20,140,255,1);
		border-radius:0.04rem;
		text-align: center;
		font-size:0.24rem;
		font-family:PingFangSC-Medium;
		font-weight:500;
		color:rgba(255,255,255,1);
	}
	.decoration{
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 1.13rem;
		background: url(../assets/img/bind_decoration@2x.png) no-repeat;
		background-size: 100%;
	}
	.btn_area{
		margin-top: 3.3rem;
		width: 100%;
		height: 0.98rem;
		background: url(../assets/img/bind_btn@2x.png) no-repeat center center;
		background-size: 6.44rem 0.98rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/bind.vue